(function () {
  /* Antes de alcanzar la barra: bubbles y filtros en su posicion natural.
   * Al pasar la barra bajo la cabecera: filtros bajando, bubbles subiendo.
   * Se conserva la sensibilidad del tema activo, sin umbrales desde la pagina. */
  const DIRECTION_THRESHOLD = 40;
  const anchors = new WeakMap();
  let lastDirectionY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
  let currentDirection = '';
  let ticking = false;
  let layoutObserver = null;

  function getVisibleBottom(element) {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;
    return Math.max(0, Math.round(rect.bottom));
  }

  function getHeaderOffset() {
    return [
      document.querySelector('.header-section'),
      document.querySelector('header.custom_main_header'),
    ].reduce(function (offset, element) {
      return Math.max(offset, getVisibleBottom(element));
    }, 0);
  }

  function getScopes() {
    const scopes = [];
    document.querySelectorAll('[data-collection-mobile-sticky-root]').forEach(function (root) {
      const scope = root.closest('.shopify-section') || root.parentElement;
      if (scope && scopes.indexOf(scope) === -1) scopes.push(scope);
    });
    return scopes;
  }

  function syncMeasurements() {
    const headerOffset = getHeaderOffset();
    const scopes = getScopes();
    scopes.forEach(function (scope) {
      const bubbles = scope.querySelector('[data-collection-mobile-bubbles]');
      scope.classList.add('collection-mobile-sticky-active');
      scope.classList.remove('collection-mobile-bubbles-visible', 'collection-mobile-toolbar-suppressed');
      scope.style.setProperty('--collection-mobile-header-offset', headerOffset + 'px');
      scope.style.setProperty('--collection-mobile-bubbles-height', (bubbles ? Math.round(bubbles.offsetHeight) : 0) + 'px');
    });
    return { scopes: scopes, headerOffset: headerOffset };
  }

  function getActivationAnchor(scope) {
    const target = scope.querySelector('[data-collection-mobile-sticky-shell]') ||
      scope.querySelector('[data-collection-mobile-bubbles]');
    if (!target) return null;
    let anchor = anchors.get(scope);
    if (!anchor || anchor.nextElementSibling !== target) {
      if (anchor) anchor.remove();
      anchor = document.createElement('span');
      anchor.setAttribute('data-collection-sticky-anchor', '');
      anchor.setAttribute('aria-hidden', 'true');
      // Esta referencia no se vuelve sticky y no reserva altura adicional.
      anchor.style.cssText = 'display:block;position:relative;height:0;min-height:0;max-height:0;margin:0;padding:0;border:0;flex:0 0 0;overflow:hidden;pointer-events:none;';
      target.before(anchor);
      anchors.set(scope, anchor);
    }
    return anchor;
  }

  function setStickyState(state) {
    document.body.classList.toggle('mobile-at-top', state === 'top');
    document.body.classList.toggle('mobile-scroll-up', state === 'up');
    document.body.classList.toggle('mobile-scroll-down', state === 'down');
    document.body.dataset.collectionScrollState = state;
  }

  function updateStickyBars() {
    ticking = false;
    const currentScrollY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    const measurements = syncMeasurements();
    const scope = measurements.scopes[0];
    if (!scope) return;
    const anchor = getActivationAnchor(scope);

    if (!anchor || anchor.getBoundingClientRect().top >= measurements.headerOffset - 1) {
      setStickyState('top');
      currentDirection = '';
      lastDirectionY = currentScrollY;
      return;
    }

    if (!scope.querySelector('[data-collection-mobile-bubbles] li')) {
      setStickyState('down');
      currentDirection = 'down';
      lastDirectionY = currentScrollY;
      return;
    }

    const distance = currentScrollY - lastDirectionY;
    if (!currentDirection) {
      // La primera activacion siempre muestra filtros, incluso con scroll restaurado.
      currentDirection = 'down';
      setStickyState('down');
      lastDirectionY = currentScrollY;
      return;
    }
    if (Math.abs(distance) < DIRECTION_THRESHOLD) return;
    currentDirection = distance > 0 ? 'down' : 'up';
    setStickyState(currentDirection);
    lastDirectionY = currentScrollY;
  }

  function requestStickyUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateStickyBars);
  }

  function init() {
    if (!getScopes().length) return;
    if (!layoutObserver && window.ResizeObserver) {
      layoutObserver = new ResizeObserver(requestStickyUpdate);
      [document.querySelector('main'), document.querySelector('.header-section'),
        document.querySelector('header.custom_main_header')].forEach(function (element) {
        if (element) layoutObserver.observe(element);
      });
    }
    requestStickyUpdate();
  }

  window.addEventListener('scroll', requestStickyUpdate, { passive: true });
  window.addEventListener('resize', function () {
    lastDirectionY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    requestStickyUpdate();
  });
  window.addEventListener('pageshow', init);
  document.addEventListener('load', requestStickyUpdate, true);
  document.addEventListener('loadedmetadata', requestStickyUpdate, true);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
